/**
 * Writes a screen has accepted but deliberately not sent yet (e.g. SRV210's undoable
 * file delete, which waits 5s before calling the API).
 *
 * Logout must send them first: it calls /logout and then removes the access token, and
 * only after that does the screen unmount. Flushing on unmount would therefore go out
 * with no token (or one the server already invalidated), the write would fail, and the
 * user would see an error on the login page while the data stays as it was.
 *
 * Module scope on purpose, like mutationDedupe: logout lives in useAuth, the pending
 * write lives in a page component, and neither knows about the other.
 */
const flushers = new Set();

/**
 * @param {() => Promise<any>} flush  sends the pending write now
 * @returns {() => void} unregister -- call it once the write was sent or cancelled
 */
export const registerPendingWrite = (flush) => {
  flushers.add(flush);
  return () => flushers.delete(flush);
};

/** Sends every pending write and waits for all of them; a failure does not stop the rest. */
export const flushPendingWrites = async () => {
  const pending = [...flushers];
  flushers.clear();
  await Promise.allSettled(pending.map((flush) => flush()));
};

/** Test seam. */
export const pendingWriteCount = () => flushers.size;
